import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class RechargeService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }


  /**
   * Description: Método que llama el servicio web de obtener listado de montos de recarga aceptados
   * Autor: Diego Diaz
   * @param N/A
   * @return Listado de valores permitidos para recargas
   */
  getAllowedRechargeValues() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_RECHARGE_ALLOWED_VALUES, "");
  }


  /**
 * Description: Método que llama el servicio web de obtener listado de tarjetas de credito guardadas
 * Autor: Diego Diaz
 * @param documentId identificación
 * @return Listado de tarjetas
 */
  getStoredCards(documentId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RECHARGE_STORED_CARDS, { "identification": documentId });
  }

  /**
 * Description: Método que llama el servicio web de eliminar tarjetas de credito guardadas
 * Autor: Diego Diaz
 * @param id identificador de la tarjeta
 * @return Confirmación de la eliminación
 */
  deleteStoredCards(id) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RECHARGE_DELETE_STORED_CARDS, { "id": id, "paymentParam": constants.PAYMENT_FORM_REST_RECHARGE });
  }

  /**
   * Description: Método que llama el servicio web de obtener formulario de pagos
   * Autor: Diego Diaz
   * @param jsonData parámetros de entrada del servicio
   * @return Formulario de pagos
   */
  getPaymentForm(jsonData) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_RECHARGE_GET_FORM, jsonData);
  }

  /**
   * Description: Método que llama el servicio de validar si un teléfono esta dentro de la marca
   * Autor: Diego Diaz
   * @param phone teléfono a validar
   * @return Formulario de pagos
   */
  validatePhoneInBrand(phone) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_VALIDATE_PHONE_IN_BRAND, { "msisdn": phone });
  }
  /**
 * Description: Método que llama el servicio para gestionar el Cancel
 * Autor: Fernando Herdoiza
 * @param idTable identificador del registro de la base de datos
 */
  startCancelAsync(idTable) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PAYMENT_CANCEL_ASYNC, { "idTable": idTable });
  }

}